module.exports = __webpack_public_path__ + "static/media/20-15.b9f4df3c.mp3";